import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { QuickCreateProvider, useQuickCreate } from "@/context/QuickCreate";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import SectionPage from "@/pages/SectionPage";
import AllTasks from "@/pages/AllTasks";
import Completed from "@/pages/Completed";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const quick = useQuickCreate();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Yükleniyor…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return <Layout onQuickCreate={() => quick.setOpen(true)}>{children}</Layout>;
};

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <BrowserRouter>
        <AuthProvider>
          <QuickCreateProvider>
            <Routes>
              <Route path="/giris" element={<Login />} />
              <Route path="/oturum" element={<AuthCallback />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/adliye" element={<Protected><SectionPage section="Adliye" /></Protected>} />
              <Route path="/turkpatent" element={<Protected><SectionPage section="TÜRKPATENT" /></Protected>} />
              <Route path="/diger" element={<Protected><SectionPage section="Diğer" /></Protected>} />
              <Route path="/isler" element={<Protected><AllTasks /></Protected>} />
              <Route path="/tamamlananlar" element={<Protected><Completed /></Protected>} />
              <Route path="/ayarlar" element={<Protected><Settings /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </QuickCreateProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
